import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';


const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    observTextField: {
        display: 'flex',
        height: '100%',
        margin: theme.spacing(1),
    },
    inputObserv: {
        display: 'flex',
        alignItems: 'start',
        margin: '15px 0',
        padding: '5px 8px',

    },
    button: {
        margin: '15px 15px 15px 0',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    title:{
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(3),        
    }
});

class TextBoxDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.obs
        };
    }


    handleValueChange = (event) => {
        this.setState({ ...this.state, value: event.target.value })
    }


    render() {

        const { classes } = this.props;

        return (
            <div>

                <Typography variant="h4" color='secondary' className={classes.title}>{this.props.title}</Typography>

                <Typography variant="subtitle2">{this.props.label}</Typography>
                <TextField
                    className={classes.observTextField}
                    placeholder={this.props.label}
                    InputProps={{
                        className: classes.inputObserv,
                    }}
                    id={'observDescuadre'}
                    value={this.state.value}
                    variant='outlined'
                    multiline
                    rowsMax='5'
                    rows='5'
                    onChange={(event) => this.handleValueChange(event)}
                />
               
                <div className={classes.bottomBtn}>
                    <Button variant="contained" color="primary" className={classes.button} disabled={this.state.value === ''} onClick={() => {
                        this.props.hideDialog();
                        this.props.okHandler(this.state.value);
                    }}>Guardar</Button>
                </div>

            </div>
        )

    }


}

TextBoxDialog.propTypes = {

    //dispatch
    hideDialog: PropTypes.func.isRequired,

    //parameters
    okHandler: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    obs: PropTypes.string.isRequired

};



export default withStyles(styles, { withTheme: true })(TextBoxDialog);